export const ONBOARDING_ROUTE = "/student/onboarding";
